import api from "@/api/api-v2-config";

export async function getMarketingLead() {    
    return await api.get("marketings/getmarketingleadlist?PageNumber=1&PageSize=10000");
}

export async function getMarketingLeadById(id) {    
    return await api.get("marketings/getmarketingleadbyid?id=" + id);
}


export async function postMarketingLead(data) {
    return await api.post("marketings/createmarketinglead", data);
}

export async function putMarketingLead(data) {
    return await api.put("marketings/updatemarketinglead", data);
}

export async function deleteMarketingLead(id) {
    return await api.delete("marketings/deletemarketinglead?id=" + id);
}

export async function convertToSales(id) {
    return await api.post("marketings/marketingleadtosaleslead?id=" + id);
}